import React, { useMemo } from "react";
import { Button, Modal, Table } from '@themesberg/react-bootstrap';

export default (props) => {

  const _onHide = () => {
    props.onHide()
  }

  const prizes = useMemo(() => {
    if (!props.result || props.result.length === 0) return [];

    const r = props.result;
    const split = (val) => ((val || '').toString()).split(/\s+/).filter(p => p);

    return [
      { label: 'ĐB', numbers: [r[0]], highlight: true },
      { label: 'G.1', numbers: [r[1]] },
      { label: 'G.2', numbers: [r[2]] },
      { label: 'G.3', numbers: split(r[3]) },
      { label: 'G.4', numbers: split(r[4]) },
      { label: 'G.5', numbers: [r[5]] },
      { label: 'G.6', numbers: split(r[6]) },
      { label: 'G.7', numbers: [r[7]] },
      { label: 'G.8', numbers: [r[8]] },
    ];
  }, [props.result]);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={_onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Kết quả
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-2">
        <Table bordered size="sm" className="mb-0 text-center">
          <tbody>
            {prizes.map((prize, idx) => (
              <tr key={idx}>
                <td style={{ width: 50, fontWeight: 600, verticalAlign: 'middle' }}
                  className={prize.highlight ? 'table-danger' : ''}>
                  {prize.label}
                </td>
                <td className={prize.highlight ? 'table-danger fw-bold' : ''}>
                  {prize.numbers.filter(Boolean).join(' - ') || '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer className="py-2">
        <Button size="sm" variant="danger" onClick={_onHide}>Đóng</Button>
      </Modal.Footer>
    </Modal>
  );
}